function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} /** @format */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import objectWithoutKeys from "../../utils/objectWithoutKeys";

const defaultProps = {
  disabled: false,
  onClick: (_e) => {},
  confirmTitle: '',
  confirmMessage: ''
};









export class I18NLink extends Component {






  static navigate(to) {
    browserHistory.push(to);
  }

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    const { to, disabled, onClick, confirmTitle, confirmMessage } = this.props;
    e.preventDefault();
    if (disabled) {
      return;
    }

    if (onClick) {
      if (confirmTitle) {
        this.context.confirm({
          accept: () => {
            onClick(e);
            I18NLink.navigate(to);
          },
          title: confirmTitle,
          message: confirmMessage
        });
      } else {
        onClick(e);
        I18NLink.navigate(to);
      }
    }
  }

  render() {
    const props = objectWithoutKeys(this.props, [
    'dispatch',
    'onClick',
    'confirmTitle',
    'confirmMessage']);

    return /*#__PURE__*/React.createElement(Link, _extends({ onClick: this.onClick }, props));
  }
}_defineProperty(I18NLink, "defaultProps", defaultProps);_defineProperty(I18NLink, "contextTypes", { confirm: PropTypes.func });

export function mapStateToProps({ locale }, ownProps) {
  return { to: `/${locale || ''}/${ownProps.to}`.replace(/\/+/g, '/') };
}

export default connect(mapStateToProps)(I18NLink);